import React from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import s from '../../FinancialReport.module.css';
import {
	FinStat,
	FinStatTypesType,
	RequestStatProdType,
} from '../../../../types/StoreReportTypes';
import StatReportActions from '../StatReportActions';
import {useLoadFinStatMutation} from '../../../../redux/DepotSlice/depotReportApi';
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import {useNavigate} from 'react-router-dom';

type Props = {
	stat: FinStat;
	filters: RequestStatProdType;
};
const StatRowEl: React.FC<Props> = ({stat, filters}) => {
	const navigate = useNavigate();
	const {type, sum_money, count} = stat;
	const [loadFinStat] = useLoadFinStatMutation();
	const typeMap: Record<FinStatTypesType, string> = {
		income: 'Замовлення',
		outcome: 'Повернення',
		order: 'Оформлення',
		bonus: 'Бонус',
	};
	const handleClickAction = async (action: string) => {
		const props = {data: filters, type};

		if (action === 'download') {
			try {
				// ждем ответ от мутации
				const response = await loadFinStat(props).unwrap(); // маппинг типа запроса → ключ в ответе
				const responseKeyMap: Record<FinStatTypesType, string> = {
					income: 'incomes',
					outcome: 'returns',
					order: 'orders',
					bonus: 'payments', // пример, подставь правильное поле
				};

				// получаем нужные данные
				const data = response[responseKeyMap[type]] ?? [];

				// создаём рабочую книгу и лист
				const workbook = new ExcelJS.Workbook();
				const sheet = workbook.addWorksheet(typeMap[type]);

				if (data.length > 0) {
					// создаём заголовки
					sheet.columns = Object.keys(data[0]).map((key) => ({
						header: key,
						key: key,
						width: 20,
					}));
					// добавляем строки
					data.forEach((row: Record<string, any>) => {
						sheet.addRow(row);
					});
				}
				// генерируем и скачиваем файл
				const buf = await workbook.xlsx.writeBuffer();
				const blob = new Blob([buf], {type: 'application/octet-stream'});
				saveAs(blob, `${typeMap[type]}_${new Date().toISOString()}.xlsx`);
			} catch (err) {
				console.error('Ошибка при скачивании Excel:', err);
			}
		}
	};
	const navigateAssist = (url: string) => {
		navigate(url, {
			state: {
				defaultFilters: {
					filter_active: 1,
					from_date: filters.from_date,
					to_date: filters.to_date,
					...(url === '/list_of_invoices' ? {type} : {}),
				},
			},
		});
	};
	const handleClickCount = () => {
		switch (type) {
			case 'income':
				navigateAssist(`/list_of_invoices`);
				break;
			case 'outcome':
				navigateAssist(`/list_of_invoices`);
				break;
			case 'order':
				navigateAssist(`/paperwork_list`);
				break;
			case 'bonus':
				navigateAssist(`/cash_order_list`);
				break;
			default:
				break;
		}
		console.log(type);
	};

	return (
		<div 
			className={`${style.tableRow} ${s.tableRow}`}
			style={{gridTemplateColumns: '2fr repeat(3, 1fr)'}}
		>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				{typeMap[type as keyof typeof typeMap]}
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				<button onClick={handleClickCount}>{count}</button>
			</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>{sum_money}</div>
			<div className={`${style.tableColumn} ${s.tableColumn}`}>
				<StatReportActions callback={handleClickAction} />
			</div>
		</div>
	);
};

export default StatRowEl;
